import { BaseOptionType } from 'components/ui/selects/types'
import get from 'lodash/get'

export const defaultGetOptionId = (option?: BaseOptionType) => get(option, 'id', '')
export const defaultGetOptionName = (option?: BaseOptionType) => get(option, 'name', '')
export const defaultLoadingMessage = 'Загрузка...'
export const defaultNoOptionsMessage = 'Значения нет в справочнике. Возможно, вы ошиблись в написании.'
